export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const LOADING = "PROFILE_LOADING";
export const ERROR = "PROFILE_ERROR";
